import React, { useState } from 'react';
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AddEditSession from '../../AddEditSession/AddEditSession';
import { Box, AppBar, Toolbar, Typography, Button, Paper } from '@mui/material';
import { Save, Cancel, ContentCopy } from '@mui/icons-material';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';
import LoadingBackdrop from '../../Common/LoadingBackdrop';
import { duplicateSession } from '../../../actions/sessionActions';
import Swal from 'sweetalert2';

const SessionsAddEditPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const isEdit = location.pathname.includes('edit');
  const [isDuplicating, setIsDuplicating] = useState(false);

  const handleDuplicate = async () => {
    const { isConfirmed } = await Swal.fire({
      title: 'Duplicate Session?',
      text: 'This will create a copy of this session (inactive by default).',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Duplicate',
    });
    if (!isConfirmed) return;

    try {
      setIsDuplicating(true);
      const newSession = await dispatch(duplicateSession(id));
      Swal.fire({
        icon: 'success',
        title: 'Session Duplicated!',
        text: `Created: ${newSession.session_name}`,
        timer: 1500,
      }).then(() => {
        navigate(`/sessions/edit/${newSession.session_id}`);
      });
    } catch (err) {
      console.error('Error duplicating session:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to duplicate session. Please try again.',
      });
    } finally {
      setIsDuplicating(false);
    }
  };

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <LoadingBackdrop open={isDuplicating} />
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? 'Edit Session' : 'Create New Session'}
          </Typography>
          {isEdit && (
            <Button
              color="info"
              onClick={handleDuplicate}
              startIcon={<ContentCopy />}
              variant="contained"
              sx={{ marginRight: 2 }}
              disabled={isDuplicating}
            >
              Duplicate
            </Button>
          )}
          <Button
            color="error"
            component={Link}
            to="/sessions"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            form="session-form"
            type="submit"
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditSession
            isEdit={isEdit}
            selectedId={id}
          />
        </Paper>
      </Box>
    </MainContentContainer>
  );
};

export default SessionsAddEditPage;
